import { render, staticRenderFns } from "./PH1Z.vue?vue&type=template&id=241cbe5c"
import script from "./PH1Z.vue?vue&type=script&lang=js"
export * from "./PH1Z.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports